const Fetcher = require('od-modules/utils/fetcher');

function bindFncOrConstant(fnc, ctx) {
    return typeof fnc === 'function' ? fnc.bind(ctx) : () => null;
}

class GenericService {
    constructor() {
        this._service = null;
        this._dispatch = null;
    }

    get service() {
        return this._service;
    }

    set service(value) {
        this._service = value;
    }

    get dispatch() {
        return this._dispatch;
    }

    set dispatch(value) {
        this._dispatch = value;
    }

    getDataRequestSettings(data) {
        return {
            data: data || null,
            dataType: 'json',
            contentType: 'application/json',
            url: this.service.getUrl(),
            type: this.service.getMethod(),
            success: bindFncOrConstant(this.service.requestSuccess, this),
            error: bindFncOrConstant(this.service.requestError, this),
        };
    }

    getRequestMethod(data) {
        const url = this.service.getUrl();
        switch (this.service.getMethod()) {
            case 'PUT':
                return Fetcher.put(url, data).json();
            case 'POST':
                return Fetcher.post(url, data).json();
            case 'GET':
            default:
                return Fetcher.get(url).json();
        }
    }

    performRequest(data, dispatch) {
        this.dispatch = dispatch || null;
        return this.getRequestMethod(data)
            .catch(bindFncOrConstant(this.service.requestError, this))
            .then(bindFncOrConstant(this.service.requestSuccess, this));
    }
}

export default GenericService;
